// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zAN3","toggle":"styles_toggle__26M8x","preview":"styles_preview__mmIUm"};